import axios from 'axios'
import { interceptor } from '@/application/utils/interceptor.js'

const domain = process.env.VUE_APP_API_PATH
const getLookupPackagesApi = `${domain}api/v1/dashboard/lookup-packages/`
const getLookupPaddleLinkApi = (packageId) => `${domain}api/v1/dashboard/lookup-buy-package/${packageId}/`

export const getLookupPackages = () => interceptor(axios).get(getLookupPackagesApi)
export const getLookupPaddleLink = (packageId, data) => interceptor(axios).post(getLookupPaddleLinkApi(packageId), data)
